import { useCallback, useMemo, type PropsWithChildren, type ReactElement } from 'react'
import { type Entitlement } from '@terros/common'
import { useToastError } from '@hooks'
import { EntitlementContext, useEntitlements } from '@front/model'
import { NotReady } from '@components'

export const EntitlementProvider = ({ children }: PropsWithChildren): ReactElement => {
  const { data, ...state } = useEntitlements()
  useToastError(state.error)

  const entitlementSet = useMemo(() => new Set(data?.entitlements), [data?.entitlements])
  const hasEntitlement = useCallback((entitlement: Entitlement) => entitlementSet.has(entitlement), [entitlementSet])
  const entitlementContext = useMemo(
    () => ({
      ...state,
      entitlements: data?.entitlements || [],
      entitlementSet,
      hasEntitlement,
      trialEntitlements: data?.trial || [],
      purchasedEntitlements: data?.purchased || [],
    }),
    [state, data, entitlementSet, hasEntitlement]
  )

  if (state.isLoading) {
    return (
      <div className='flex min-h-screen items-center'>
        <NotReady isLoading />
      </div>
    )
  }

  return <EntitlementContext.Provider value={entitlementContext}>{children}</EntitlementContext.Provider>
}
